import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import LanguageCurrencyFullScreenProps, {
  LanguageCurrencyFullScreenHandle
} from './props';

import logoYWLarge from '../../../../../icons/LuxYW-name.svg';
import './styles.scss';

const LanguageCurrencyFullScreen = forwardRef<
  LanguageCurrencyFullScreenHandle,
  LanguageCurrencyFullScreenProps
>((props, ref) => {
  const { children, initiallyShowFullScreen } = props;

  const [isOpen, setIsOpen] = useState(!!initiallyShowFullScreen);
  const [isClosing, setIsClosing] = useState(false);

  const fullScreenRef = useRef<HTMLDivElement>(null);

  const openFullScreen = () => {
    setIsOpen(true);
  };

  const closeFullScreen = () => {
     setIsClosing(true);
  };

  const handleAnimationEnd = () => {
    if (isClosing) {
      setIsClosing(false);
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll-language-full-screen');
    }
    return () => {
      document.body.classList.remove('no-scroll-language-full-screen');
    };
  }, [isOpen]);

  useImperativeHandle(ref, () => ({
    openFullScreen,
    closeFullScreen
  }));

  if (!isOpen && !isClosing) return null;

  const fullScreenClassName = `language-currency-fullscreen ${isClosing ? 'fullscreen-exit' : ''}`;

  return (
    <>
      <div
        ref={fullScreenRef}
        className={fullScreenClassName}
        data-e2e="language-currency-fullscreen"
        onAnimationEnd={handleAnimationEnd}
      >
        <div className="language-currency-fullscreen__header">
          <span className="language-currency-fullscreen__header-title">
            {props.headerTitle}
          </span>
          <button
            className="language-currency-fullscreen__close-btn"
            onClick={closeFullScreen}
          >
            ✕
          </button>
        </div>
        <div className="language-currency-fullscreen__header--mobile">
          <img src={logoYWLarge} alt="Logo" />
          <button
            className="language-currency-fullscreen__close-btn"
            onClick={closeFullScreen}
          >
            ✕
          </button>
        </div>
        <div className="language-currency-picker__full-screen">
          {children}
        </div>
      </div>
      <div className="language-currency-fullscreen__background"></div>
    </>
  );
});

LanguageCurrencyFullScreen.displayName = 'LanguageCurrencyFullScreen';

export default LanguageCurrencyFullScreen;
